import { Box, TableCell, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  rowId: string;
  status: string;
  key: string;
  headerIndex: number;
  handleApprove?: (id: string) => void | Promise<void>;
  handleReject?: (id: string) => void | Promise<void>;
  isApproving?: boolean;
  isRejecting?: boolean;
};

export function RowCellLearningActions({
  rowId,
  status,
  key,
  headerIndex,
  handleApprove,
  handleReject,
  isApproving,
  isRejecting,
}: Props) {
  const isPending = status === 'PENDING_REVIEW' || status === 'NEEDS_REVIEW';

  return (
    <TableCell key={key || headerIndex} align="right">
      {isPending && (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <IconButton
            color="success"
            size="small"
            disabled={isApproving}
            onClick={() => handleApprove?.(rowId)}
          >
            <Iconify icon="solar:check-circle-bold" width={20} />
          </IconButton>
          <IconButton
            color="error"
            size="small"
            disabled={isRejecting}
            onClick={() => handleReject?.(rowId)}
          >
            <Iconify icon="solar:close-circle-bold" width={20} />
          </IconButton>
        </Box>
      )}
    </TableCell>
  );
}
